export enum FormCustomForms {
    UseCustomers = 'use-customers',
    UseMeteringPoints = 'use-meteringpoints',
    UseHotMeteringPoints = 'use-hot-meteringpoints',
    UseColdMeteringPoints = 'use-cold-meteringpoints'
}